import Icon from "icons"
import styled from "styled-components"

import { maxWidth } from "utils"

export const Container = styled.div`
  display: none;
  justify-content: flex-end;
  align-items: center;
  flex: 0 0 50%;

  button {
    margin-left: 3.5rem;
  }
  ${maxWidth.tablet`
    width: 100%;
    flex-direction: row;
    position: fixed;
    bottom: 0;
    background: ${(props) => props.theme.component.background};
    padding: 10px 20px;
    z-index: 5;
    flex: 0 0 100%;
    justify-content: center;
    button {
      margin-left: 1.75rem;
      width: 50%;
    }
    `}
  ${maxWidth.mobile`
  flex-direction: column;
     button{
        margin-left: 0rem;
        width: 100%;
        margin-top: 1rem;
      }
`}
`
export const SelectWrapper = styled.div`
  margin-bottom: 0;
  position: relative;
  width: 18rem;
  ${maxWidth.tablet`
    width:50%;
  `}
  ${maxWidth.mobile`
    width:100%;
  `}
`
export const Select = styled.select`
  background-color: #fff;
  transition: none;
  text-transform: capitalize;
  margin-bottom: 0;
  min-width: 8rem;
  border: 1px solid #c8c8c8;
  border-radius: 30px;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 1.4rem;
  height: 4rem;
  padding: 0 4.5rem 0 1.8rem;
  text-align: left;
  transition: border 0.3s ease-in-out;
  width: 100%;
  appearance: none;
  &:hover {
    border: 1px solid #ec5d2a;
  }
`
export const SelectArrow = styled(Icon)`
  height: 1.4rem;
  position: absolute;
  right: 2.5rem;
  top: 50%;
  transform: translateY(-50%) rotate(90deg);
  width: 1.2rem;
  pointer-events: none;

  g {
    fill: ${(props) => props.theme.colors.text.primary};
  }
`
